import React, { useRef, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { hasPersistentRage, mergeRage, rageProfile } from '../../../shared/rules/barbarianRage.mjs';
import apiFetch from '../../../utils/apiFetch';
import { notify } from '../../../utils/notification';

/** Persistent Rage (Barbarian 15): offered when Initiative is rolled with Rage uses spent; once per Long Rest. */
export default function PersistentRagePrompt({ form, characterId, campaignId, combatState, onCharacterChange, onCombatStateReconciled }) {
  const [busy, setBusy] = useState(false);
  const lock = useRef(false);
  const participant = combatState?.participants?.find((p) => String(p.characterId) === String(characterId));
  const roll = participant?.initiativeRoll, offer = roll?.persistentRage;
  const profile = rageProfile(form);
  const show = hasPersistentRage(form) && !profile.raw.persistentRefillUsed && offer?.status === 'pending'
    && offer.turnSequence === (combatState?.turnSequence || 0);
  const decide = async (decision) => {
    if (lock.current || !show) return;
    lock.current = true; setBusy(true);
    try {
      const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/initiative/persistent-rage`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ combatantId: String(characterId), rollId: roll.id, decision }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || 'Rage could not be saved.');
      onCombatStateReconciled?.(result.combat);
      if (result.rage) onCharacterChange?.((previous) => mergeRage(previous, result.rage));
      if (decision === 'use') notify(`Persistent Rage: all ${profile.maximum} Rage uses regained.`, 'success');
    } catch (error) { notify(error.message || 'Rage could not be saved.', 'danger'); }
    finally { lock.current = false; setBusy(false); }
  };
  return (
    <Modal centered show={Boolean(show)} onHide={() => decide('decline')} backdrop={busy ? 'static' : true} keyboard={!busy} className="dnd-modal modern-modal" aria-label="Persistent Rage">
      <Modal.Header closeButton={!busy}><Modal.Title>Persistent Rage</Modal.Title></Modal.Header>
      <Modal.Body>You rolled Initiative with {profile.current} of {profile.maximum} Rage uses left. Regain all of them now? You can do this once per Long Rest.</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" disabled={busy} onClick={() => decide('decline')}>Save it for later</Button>
        <Button disabled={busy} onClick={() => decide('use')}>{busy ? 'Saving…' : 'Regain Rage'}</Button>
      </Modal.Footer>
    </Modal>
  );
}
